import classes from "./MessagingContentCard.module.css";
import Icons from "../../../../resources/icons/Icons";
import Strings from "../../../../resources/Strings";
import { Divider } from "@mui/material";
import { MESSAGING_PARKERS_TABLE_COLUMNS } from "../../../../constants/Constants";
import store from "../../../../redux/Store";
import { commonActions } from "../../../../redux/reducers/CommonReducer";
import { TableModalEntity } from "../../../../entities/UIEntities/TableModalEntity";
import { TABLES } from "../../../../enums/Enums";
import { useSelector } from "react-redux";
import { getMessagingParkersData } from "../../../../utils/MessagingUtils";

const MessagingParkersContentCard = (props) => {
  const currentScopeUsers = useSelector((state) => state.messaging.currentScopeUsers);
  const currentGmtUsers = useSelector((state) => state.user.currentGmtUsers);
  const currentUsers = currentScopeUsers.concat(currentGmtUsers);

  // if user founded twice (for example admin that is also parker - cause of concat) 
  // - give priority to his user with userTypes (shows his user as tenant by filter out by userTypes)
  const foundedScopeUsers = currentUsers?.filter(cur => props.mailingListToUsers?.some(mlto => cur.utronUser.id === mlto.userId))?.filter(cur => cur.utronUser?.userToUserTypes?.length > 0); 
  const usersToRows = getMessagingParkersData(foundedScopeUsers);

  const openTableModal = () => {
    const campaignTableModal = new TableModalEntity(
      `${Strings.PARKERS} (${props?.size})`,
      MESSAGING_PARKERS_TABLE_COLUMNS,
      usersToRows,
      TABLES.MODAL_TABLE
    );

    store.dispatch(commonActions.setTableModal(campaignTableModal));
  };

  return (
    <div className={classes.contentCardContainer}>
      <Divider />
      <div className={classes.messagingContainer}>
        <div className={classes.messagingItem}>
          <div className={[classes.total, classes.open].join(' ')} onClick={openTableModal}><img src={Icons.EXTERNAL} />{Strings.VIEW_PARKERS} ({props?.size})</div>
        </div>
      </div>
      <Divider />
    </div>
  );
};

export default MessagingParkersContentCard;
